import React from 'react';
import Home from './components/Home';
import Product from './components/Product';
import Layout from './components/Layout';
import Sports from './components/Sports';
import Ocr from './components/Ocr';
import Agri from  './components/Agri';
import Consulting from './components/Consulting';
import Bootcamp from './components/Bootcamp';
import Training from './components/Training';
import Aboutcompany from './components/Aboutcompany';
import HireandManage from './components/HireandManage';
import Insights from './components/Insights';
import PagetoSupport from './components/PagetoSupport';
import Jobposting from './components/Jobposting';
import Contactpage from './components/Contactpage';

import { Routes, Route } from 'react-router-dom';


function App() {
  return (
    <Routes>
      
      <Route path='/' element={<Home />} />
      <Route path='/Home' element={<Home />} />
      <Route path='/Sports' element={<Sports />} />
      <Route path='/Ocr' element={<Ocr />} />
      <Route path='/Agri' element={<Agri />} />
      <Route path='/Consulting' element={<Consulting />} />
      <Route path='/Bootcamp' element={<Bootcamp />} />
      <Route path='/Hireandmanage' element={<HireandManage />} />
      <Route path='/Training' element={<Training />} />
      <Route path='/Aboutcompany' element={<Aboutcompany />} />
      <Route path='/Insights' element={<Insights />} />
      <Route path='/Pagetosupport' element={<PagetoSupport />} />
      <Route path='/Jobposting' element={<Jobposting />} />
      <Route path='/Contactpage' element={<Contactpage />} />




    

    </Routes>
  );
}

export default App;
